import React, { useState, useEffect, useRef } from "react";
import {
  Form,
  message,
  Col,
  Row,
  Button,
  Card,
  Divider,
  Segmented,
  Spin,
  Modal,
  Typography,
  Space,
  InputNumber,
  Input,
  Table,
} from "antd";
import api from "utils/api";
import PatientForm from "./PatientForm";
import BillingTable from "./BillingTable";
import utils from "utils";
import VenderForm from "./VenderForm";
import dayjs from "dayjs";

const fieldOptionsInitial = {
  patient: {
    name: { options: [], loading: false },
    contact_number: { options: [], loading: false },
    patient_id: { options: [], loading: false },
  },
  vendor: {
    name: { options: [], loading: false },
    contact_number: { options: [], loading: false },
    vendor_id: { options: [], loading: false },
  },
};
const App = (props) => {
  const dataType =
    props?.editData?.type || (props?.VendorDetail ? "vendor" : "patient");
  const [form] = Form.useForm();
  const [dataSource, setDataSource] = useState([]);
  const [selectedType, setSelectedType] = useState(dataType);
  const [fieldOptions, setFieldOptions] = useState(fieldOptionsInitial);
  const [formActionState, formAction] = useState(
    !!(props?.editData?.type || props?.VendorDetail)
  );
  const [selectedPatientData, setSelectedPatientData] = useState({});
  const [buttonLoad, setButtonLoader] = useState(false);
  const [isGenerated, setIsGenerated] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const previousPaymentStatus = useRef("");
  const [paidAmount, setPaidAmount] = useState(0);
  const [showReferenceIdFields, setShowReferenceIdFields] = useState(false);
  const { Text } = Typography;
  const setPreviousPaymentStatus = (value) => {
    previousPaymentStatus.current = value;
  };
  const fetchAutocompleteOptions = async (fieldName, searchText = "") => {
    setFieldOptions((prevState) => ({
      ...prevState,
      [selectedType]: {
        ...prevState[selectedType],
        [fieldName]: {
          ...prevState[selectedType][fieldName],
          loading: true,
        },
      },
    }));
    let options = [];
    try {
      const query = new URLSearchParams({
        search: searchText,
        field_name: fieldName,
        type: selectedType.toLowerCase(),
      }).toString();
      const response = await api.fetchNewBillingFieldSearch(query);
      if (response.data.status === 200) {
        options = response.data.data.results.map((result, index) => ({
          value: result[fieldName],
          label: result[fieldName],
          ...result,
          key: index,
        }));
      } else {
        message.error(`Failed to fetch ${fieldName} options`);
      }
    } catch (error) {
      console.error(`Error fetching ${fieldName} options:`, error);
      message.error(`Failed to fetch ${fieldName} options`);
    } finally {
      setFieldOptions((prevState) => ({
        ...prevState,
        [selectedType]: {
          ...prevState[selectedType],
          [fieldName]: {
            options: options,
            loading: false,
          },
        },
      }));
    }
  };
  useEffect(() => {
    if (props?.editData) {
      setFieldValues();
    }
    if (props?.VendorDetail) {
      const {
        name,
        patient_vendor_id,
        contact_number,
        GSTIN_number,
        // vendor_order_id,
      } = props.VendorDetail;
      const selectedData = {
        name,
        vendor_id: patient_vendor_id,
        contact_number,
        GSTIN_number,
        // vendor_order_id,
      };
      form.setFieldsValue(selectedData);
    }
  }, []);

  useEffect(() => {
    props?.formAction(formActionState);
    return () => props?.formAction(false);
  }, [formActionState]);

  useEffect(() => {
    const initialPaymentStatus = form.getFieldValue("payment_status");
    setPreviousPaymentStatus(initialPaymentStatus);
  }, []);

  const unsavedPopup = (key) => {
    utils.Modal(true, {
      width: "650px",
      // closable: false,
      content: (
        <div className="finish-Consult-Modal">
          <div className="finish-header">Switch Tab</div>
          <div className="finish-wrapper">
            <div className="finish-title">
              There are unsaved changes. Are you sure to switch Tab?
            </div>
            <div className="finish-btns">
              <button
                className="action-yes"
                onClick={() => {
                  setSelectedTypepre(key);
                  formAction(false);
                  utils.Modal(false);
                }}
              >
                Yes
              </button>
              <button
                className="action-no"
                onClick={() => {
                  utils.Modal(false);
                }}
              >
                No
              </button>
            </div>
          </div>
        </div>
      ),
    });
  };
  function setFieldValues() {
    if (props.editData.type == "patient") {
      const {
        name,
        patient_id,
        contact_number,
        payment_mode,
        billing_date,
        payment_status,
        reference_id,
      } = props.editData;
      let formattedBillingDate = dayjs(billing_date, "YYYY-MM-DD hh:mm:ss");
      if (!formattedBillingDate.isValid()) {
        formattedBillingDate = dayjs();
      }

      const selectedData = {
        name,
        patient_id,
        contact_number,
        payment_mode: "",
        billing_date: formattedBillingDate,
        payment_status,
        reference_id: "",
      };
      if (
        !(props.editData.is_generated && payment_status === "Partially paid")
      ) {
        selectedData.payment_mode = payment_mode;
        selectedData.reference_id = reference_id;
      }
      form.setFieldsValue(selectedData);
      setDataSource(
        props.editData.item_details.map((item, index) => ({
          ...item,
          key: index + 1,
        }))
      );
    }

    if (props.editData.type == "vendor") {
      const {
        name,
        vendor_id,
        contact_number,
        payment_mode,
        billing_date,
        payment_status,
        GSTIN_number,
        reference_id,
        vendor_order_id,
      } = props.editData;
      let formattedBillingDate = dayjs(billing_date, "YYYY-MM-DD hh:mm:ss");
      if (!formattedBillingDate.isValid()) {
        formattedBillingDate = dayjs();
      }
      const selectedData = {
        name,
        vendor_id,
        contact_number,
        payment_mode: "",
        billing_date: formattedBillingDate,
        payment_status,
        GSTIN_number,
        reference_id: "",
        vendor_order_id,
      };
      if (
        !(props.editData.is_generated && payment_status === "Partially paid")
      ) {
        selectedData.payment_mode = payment_mode;
        selectedData.reference_id = reference_id;
      }
      form.setFieldsValue(selectedData);
      setDataSource(
        props.editData.item_details.map((item, index) => ({
          ...item,
          key: index + 1,
        }))
      );
    }
  }
  const handleAutocompleteChange = (fieldName, value) => {
    fetchAutocompleteOptions(fieldName, value);
  };

  const handleAutocompleteSelect = (fieldName, value, option) => {
    setSelectedPatientData(option);
  };

  const handleFormChange = (changedFields, allFields) => {
    if (!formActionState) {
      formAction(true);
    }
    if (changedFields && changedFields.length > 0) {
      const changedField = changedFields[0];
      if (changedField && changedField.name && changedField.name.length > 0) {
        const fieldName = changedField.name[0];

        const paymentModeValue = form.getFieldValue("payment_mode");
        const paymentStatusValue = form.getFieldValue("payment_status");
        const referenceIdValue = form.getFieldValue("reference_id");

        if (fieldName === "paid_amount") {
          if (remainingAmount === 0) {
            form.setFieldsValue({ payment_status: "Paid" });
          } else if (remainingAmount > 0 && paymentStatusValue === "Paid") {
            form.setFieldsValue({ payment_status: "Partially paid" });
          }
        }
        if (
          fieldName === "payment_status" &&
          previousPaymentStatus.current !== paymentStatusValue
        ) {
          setPreviousPaymentStatus(previousPaymentStatus.current);
        }
        if (fieldName === "payment_mode" || fieldName === "payment_status") {
          if (paymentModeValue === "CASH") {
            form.setFields([{ name: "reference_id", value: "" }]);
          }
          if (fieldName === "payment_status") {
            if (
              (paymentStatusValue === "Paid" ||
                paymentStatusValue === "Partially paid") &&
              paymentModeValue
            ) {
              setIsModalOpen(true);
            }
          }
          if (
            (paymentStatusValue === "Paid" ||
              paymentStatusValue === "Partially paid") &&
            paymentModeValue &&
            paymentModeValue !== "CASH" &&
            !referenceIdValue
          ) {
            form.setFields([
              { name: "reference_id", errors: ["Reference ID is required"] },
            ]);
            // if (fieldName === "payment_status") {
            //   setIsModalOpen(true);
            // }
          } else {
            form.setFields([{ name: "reference_id", errors: [] }]);

            if (
              (paymentStatusValue === "Paid" ||
                paymentStatusValue === "Partially paid") &&
              !paymentModeValue
            ) {
              form.setFields([
                { name: "payment_mode", errors: ["Payment mode is required"] },
              ]);
              setTimeout(() => {
                form.setFields([
                  {
                    name: "payment_status",
                    value: previousPaymentStatus.current,
                  },
                ]);
              }, 100);
            } else if (paymentStatusValue === "Cancelled") {
              setIsModalOpen(true);
            } else {
              form.setFields([{ name: "payment_mode", errors: [] }]);
            }
          }
        }
        if (changedField.name[0] === "items") {
          const items = form.getFieldValue("items");
          const updatedDataSource = dataSource.map((item, index) => {
            if (changedField.name[1] === index) {
              const unit_price = items[index]?.unit_price || 0;
              const quantity = items[index]?.quantity || 1;
              // const price = selectedType=="patient" ? items[index]?.price : (unit_price * quantity);
              const price = unit_price * quantity;
              const discount = items[index]?.discount || 0;
              const amount = price - (price * discount) / 100;

              return {
                ...item,
                ...items[index],
                price,
                amount,
              };
            }
            return item;
          });
          setDataSource(updatedDataSource);

          form.setFieldsValue({
            items: updatedDataSource,
          });
        }
      }
    }
  };

  const handleTypeChange = (value) => {
    setSelectedTypepre(value);
  };
  function setSelectedTypepre(value) {
    form.resetFields();
    form.setFieldsValue({ items: [] });
    setSelectedPatientData({});
    setFieldOptions(fieldOptionsInitial);
    setDataSource([]);
    setSelectedType(value);
  }
  const calculateTotalAmount = () => {
    return (
      dataSource.reduce((sum, item) => sum + parseFloat(item.amount), 0) || 0
    );
  };
  const totalAmount = calculateTotalAmount();
  const tax = 5;
  const taxAmount = Math.round(totalAmount * (tax / 100));
  const finalAmount = (parseFloat(totalAmount) + taxAmount).toFixed(2);
  const roundFinalAmount = Math.round(finalAmount);
  const remainingAmount =
    roundFinalAmount -
    (paidAmount +
      (props?.editData?.payment_details?.reduce(
        (sum, item) => sum + parseFloat(item.partial_amount),
        0
      ) || 0));
  const handlePaidAmountChange = (value) => {
    setPaidAmount(value);
  };
  const handleAdd = (values, key) => {
    let is_generated;
    if (props?.editData?.is_generated) {
      is_generated = true;
    } else {
      is_generated = key == "Generate";
    }
    if (
      props?.editData?.payment_details?.length > 1 &&
      values.payment_status == "Partially paid"
    ) {
      message.warning(
        "Maximum of Three Partial Payment is allowed, please change Payment Status into Paid"
      );
      return;
    }
    const billing_id = props?.editData?.billing_id || "";
    const newPaymentDetail = {
      reference_id: values.reference_id || "",
      payment_mode: values.payment_mode || "",
      partial_amount:
        values.payment_status == "Paid" ? remainingAmount : paidAmount,
        paid_date:"",
        payment_id:"",
    };
    const paymentDetails = props?.editData?.payment_details?.[0]?.paid_date
      ? [...props.editData.payment_details, newPaymentDetail]
      : [{...newPaymentDetail,payment_id:props?.editData?.payment_details?.[0]?.payment_id||""}];
    let payload = {
      billing_id: billing_id,
      billing_date: values.billing_date.format("YYYY-MM-DD HH:mm:ss"),
      is_generated: is_generated,
      item_details: dataSource.map(
        ({
          description,
          price,
          discount,
          amount,
          hsn = "",
          item_id = "",
          quantity = 0,
          unit_price = 0,
          unit_measurement = "",
        }) => ({
          description,
          price,
          discount,
          amount,
          hsn,
          item_id,
          quantity,
          unit_price,
          unit_measurement,
        })
      ),
      total_amount: totalAmount,
      tax: tax,
      payment_status: values.payment_status,
      tax_amount: parseFloat(taxAmount),
      final_amount: parseFloat(finalAmount),
      payment_mode: values.payment_mode || "",
      reference_id: values.reference_id || "",
      reason: values.reason_for_cancel || "",
      vendor_order_id: "",
      appointment_id: "",
      doctor_id: "",
      payment_details: paymentDetails,
    };
    if (selectedType == "patient") {
      payload.patient_id = values.patient_id;
      if (values.appointment_date) {
        payload.appointment_id = values.appointment_date || "";
      } else {
        payload.doctor_id = values.doctor_name || "";
      }
    }
    if (selectedType == "vendor") {
      payload.vendor_id = values.vendor_id;
      // payload.GSTIN_number = values.GSTIN_number || "";
      payload.vendor_order_id = values.vendor_order_id || "";
    }
    setButtonLoader(true);
    setIsGenerated(key == "Generate");
    api
      .billing_save(payload)
      .then((response) => {
        if (response.data?.status === 200) {
          // if (key === "primary") {
          //   form.resetFields();
          //setDataSource([])
          // }`Bill ${key} successfully`
          message.success(`Bill ${key}d successfully`);
          props.submitButtonAction();
          // props.formAction(false);
        } else {
          message.error(response.data?.message);
        }
      })
      .catch((err) => {
        message.error("Something went wrong");
      })
      .finally(() => {
        setButtonLoader(false);
      });
  };

  const handleSubmit = (key) => {
    form
      .validateFields()
      .then(() => {
        const fieldValues = form.getFieldsValue();

        handleAdd({ ...fieldValues }, key);
      })
      .catch((err) => {
        console.log(err);
      });
  };
  const formatNumberWithCommas = (number) => {
    return number.toLocaleString("en-IN");
  };
  const handleModalOk = () => {
    setIsModalOpen(false);
    if (form.getFieldValue("payment_status") === "Cancelled") {
      form.setFieldsValue({ payment_mode: "" });
    }
  };
  const handleModalCancel = () => {
    // form.setFieldsValue({ payment_status: "Pending" });
    form.setFieldsValue({ payment_status: previousPaymentStatus.current });
    form.setFields([{ name: "reference_id", errors: [] }]);
    setIsModalOpen(false);
  };
  const getTitleColorAndBackground = () => {
    const title = form.getFieldValue("payment_status");
    if (title === "Paid") {
      return {
        color: "#70369D",
        backgroundColor: "#B89BCE",
      };
    } else if (title === "Cancelled") {
      return {
        color: "#FE5050",
        backgroundColor: "#FEB6B7",
      };
    }
    return {
      color: "#70369D",
      backgroundColor: "#B89BCE",
    };
  };
  const titleStyle = getTitleColorAndBackground();
  const showReferenceIdModal = () => {
    setShowReferenceIdFields(true);
  };
  return (
    <>
      <Spin
        tip={`Bill generated for ${form.getFieldValue(
          "name"
        )}-₹ ${formatNumberWithCommas(roundFinalAmount)}`}
        spinning={buttonLoad && isGenerated}
        fullscreen
      >
        <Modal
          open={isModalOpen}
          onOk={handleModalOk}
          onCancel={handleModalCancel}
          centered
          width={350}
          footer={null}
          closable={false}
        >
          <Card
            title={
              form.getFieldValue("payment_status") === "Paid" ||
              "Partially paid"
                ? "PAYMENT CONFIRMATION"
                : form.getFieldValue("payment_status") === "Cancelled"
                ? "CANCEL CONFIRMATION"
                : ""
            }
          >
            <p>Are you sure to change the payment status</p>
            <div style={{ float: "right" }}>
              <Space style={{ gap: "10px" }}>
                <Button onClick={handleModalCancel} style={{ width: "70px" }}>
                  No
                </Button>
                <Button
                  onClick={handleModalOk}
                  style={{
                    // color: "#70369D",
                    // backgroundColor: "#B89BCE",
                    color: titleStyle.color,
                    backgroundColor: titleStyle.backgroundColor,
                    width: "70px",
                  }}
                >
                  Yes
                </Button>
              </Space>
            </div>
          </Card>
        </Modal>
        <Modal
          open={showReferenceIdFields}
          onOk={() => setShowReferenceIdFields(false)}
          onCancel={() => setShowReferenceIdFields(false)}
          centered
          width={450}
          footer={null}
        >
          <Table
            dataSource={props?.editData?.payment_details?.map(
              (item, index) => ({
                ...item,
                key: index,
              })
            )}
            columns={[
              {
                title: "REFERENCE ID",
                dataIndex: "reference_id",
                key: "reference_id",
              },
              {
                title: "PAYMENT MODE",
                dataIndex: "payment_mode",
                key: "payment_mode",
              },
              {
                title: "PARTIAL AMOUNT",
                dataIndex: "partial_amount",
                key: "partial_amount",
              },
              {
                title: "PAID DATE",
                dataIndex: "paid_date",
                key: "paid_date",
              },
            ]}
            pagination={false}
            className="new-billing-table"
          />
        </Modal>
        <Form
          form={form}
          onFieldsChange={handleFormChange}
          // onFinish={handleSubmit}
          labelAlign="left"
          labelCol={{ span: 10 }}
          wrapperCol={{ span: 14 }}
          disabled={props?.editData?.is_generated}
          colon={false}
        >
          <Row gutter={[10, 10]}>
            <Col span={8}>
              <Card style={{ width: "100%" }} className="patient-ventor-card">
                <div
                  style={{
                    marginBottom: 16,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <Segmented
                    options={[
                      {
                        label: <div>Patient</div>,
                        value: "patient",
                      },
                      {
                        label: <div>Vendor</div>,
                        value: "vendor",
                      },
                    ]}
                    value={selectedType}
                    onChange={formActionState ? unsavedPopup : handleTypeChange}
                    disabled={props?.editData?.type}
                  />
                </div>
                {selectedType == "patient" && (
                  <PatientForm
                    form={form}
                    fieldOptions={fieldOptions["patient"]}
                    selectedPatientData={selectedPatientData}
                    handleAutocompleteChange={handleAutocompleteChange}
                    handleAutocompleteSelect={handleAutocompleteSelect}
                    editData={props?.editData}
                    showReferenceIdModal={showReferenceIdModal}
                  />
                )}
                {selectedType == "vendor" && (
                  <VenderForm
                    form={form}
                    fieldOptions={fieldOptions["vendor"]}
                    selectedPatientData={selectedPatientData}
                    handleAutocompleteChange={handleAutocompleteChange}
                    handleAutocompleteSelect={handleAutocompleteSelect}
                    editData={props?.editData}
                    showReferenceIdModal={showReferenceIdModal}
                  />
                )}
                {/* {props?.editData?.order_number && (
                  <Form.Item name="order_number" label="Order ID" colon={false}>
                    <Text>{`${props.editData.order_number}`}</Text>
                  </Form.Item>
                )} */}
                {props?.editData?.bill_number && (
                  <Form.Item name="bill_number" label="Bill ID" colon={false}>
                    <Text>{`${props.editData.bill_number}`}</Text>
                  </Form.Item>
                )}
              </Card>
              {calculateTotalAmount() > 0 && (
                <Card
                  style={{ marginTop: 16, width: "100%" }}
                  className="totalAmountCard"
                >
                  <Row justify="start" style={{ padding: "10px 18px" }}>
                    <Col
                      span={20}
                      style={{ fontSize: "13px", fontWeight: "bold" }}
                    >
                      TOTAL AMOUNT
                    </Col>
                    <Col span={4} style={{ fontSize: "13px" }}>
                      {`₹${formatNumberWithCommas(totalAmount)}`}
                    </Col>
                  </Row>

                  <Divider />
                  <Row style={{ padding: "2px 18px" }}>
                    <Col
                      span={20}
                      style={{ fontSize: "13px", fontWeight: "bold" }}
                    >
                      TAX {tax}%
                    </Col>
                    <Col span={4} style={{ fontSize: "13px" }}>
                      {`₹${formatNumberWithCommas(taxAmount)}`}
                    </Col>
                  </Row>
                  <Divider />
                  <Row style={{ padding: "2px 18px" }}>
                    <Col
                      span={20}
                      style={{ fontSize: "13px", fontWeight: "bold" }}
                    >
                      TOTAL AMOUNT TO BE PAID
                      <p
                        style={{
                          marginTop: "10px",
                          fontSize: "12px",
                          color: "#B5C0D0",
                          textTransform: "capitalize",
                        }}
                      >
                        {`${utils.numberToWords(
                          roundFinalAmount -
                            (props?.editData?.payment_details?.reduce(
                              (sum, item) =>
                                sum + parseFloat(item.partial_amount),
                              0
                            ) || 0)
                        )}`}
                      </p>
                    </Col>
                    <Col span={4} style={{ fontSize: "13px" }}>
                      {/* ₹{finalAmount} */}
                      {`₹${formatNumberWithCommas(
                        roundFinalAmount -
                          (props?.editData?.payment_details?.reduce(
                            (sum, item) =>
                              sum + parseFloat(item.partial_amount),
                            0
                          ) || 0)
                      )}`}
                    </Col>
                  </Row>
                  <Form.Item noStyle shouldUpdate>
                    {({ getFieldValue }) => {
                      const paymentStatus = getFieldValue("payment_status");
                      return (
                        paymentStatus === "Partially paid" && (
                          <>
                            <Row style={{ padding: "2px 18px" }}>
                              <Col
                                span={18}
                                style={{ fontSize: "13px", fontWeight: "bold" }}
                              >
                                PAID AMOUNT
                              </Col>
                              <Col
                                span={6}
                                style={{ fontSize: "13px" }}
                                className="paidAmount"
                              >
                                <Form.Item
                                  name="paid_amount"
                                  rules={[
                                    {
                                      required: true,
                                      message: `Paid amount is required`,
                                    },
                                    {
                                      validator: (_, value) => {
                                        if (
                                          value < 0 ||
                                          value > roundFinalAmount
                                        ) {
                                          return Promise.reject(
                                            new Error(
                                              `Amount should be between 0 to ${roundFinalAmount}`
                                            )
                                          );
                                        }
                                        return Promise.resolve();
                                      },
                                    },
                                  ]}
                                >
                                  <InputNumber
                                    // min={0}
                                    // max={roundFinalAmount}
                                    value={paidAmount}
                                    onChange={handlePaidAmountChange}
                                    formatter={(value) => `₹${value}`}
                                    disabled={false}
                                    // parser={(value) => value.replace("₹", "")}
                                  />
                                </Form.Item>
                              </Col>
                            </Row>
                            <Divider />
                            <Row style={{ padding: "2px 18px" }}>
                              <Col
                                span={20}
                                style={{ fontSize: "13px", fontWeight: "bold" }}
                              >
                                REMAINING AMOUNT
                                <p
                                  style={{
                                    marginTop: "10px",
                                    fontSize: "12px",
                                    color: "#B5C0D0",
                                    textTransform: "capitalize",
                                  }}
                                >
                                  {`${utils.numberToWords(remainingAmount)}`}
                                </p>
                              </Col>
                              <Col span={4} style={{ fontSize: "13px" }}>
                                {`₹${remainingAmount}`}
                              </Col>
                            </Row>
                          </>
                        )
                      );
                    }}
                  </Form.Item>
                </Card>
              )}
            </Col>
            <Col span={16}>
              <BillingTable
                dataSource={dataSource}
                setDataSource={setDataSource}
                form={form}
                selectedType={selectedType}
                handleSubmit={handleSubmit}
                buttonLoad={buttonLoad}
                editData={props?.editData}
              />
            </Col>
          </Row>
        </Form>
      </Spin>
    </>
  );
};

export default App;
